import router from '@/router';

export function handleUnauthorized(error) {
    if (error?.response?.status === 401) {
        // Limpa o usuário do localStorage e redireciona para o login
        window.localStorage.setItem("myUser", JSON.stringify({}));
        router.push({ name: 'Login' });
    }
}